<template>
  <div>
    <Datatable ref="datatable" route="/reclamation/liste" :fields="fields" :data_filters="filters" titre="Liste des reclamations" :sort="sort">      
      <template #action>  
        <b-button variant="success" class="mr-2 btn-icon" size="md" @click="tableToCSV()">
            <i class="fas text-white fa-size" :class="csv_loader ? 'fa-spin fa-spinner' : 'fa-file-excel'"></i>
        </b-button>                        
        <b-button variant="primary" class="btn-icon" size="md" @click="newRec()"><i class="fas fa-plus"></i></b-button>     
      </template>            
      <template #cell(action)="data">
        <b-form-checkbox v-model="selected" :key="data.item.id" :value="data.item.id" size="lg" inline >
          <i class="fa fa-star text-warning" v-if="checkSelect(data.item.id)"></i>
        </b-form-checkbox>              
      </template>                          
      <template #cell(user_id)="data">
        <span v-if="data.value">{{ $api.getParam('User', data.value).titre }}</span>
      </template>      
      <template #cell(date_reception)="data">
        {{ $api.moment(data.value).format("DD/MM/YYYY") }}
      </template>     
      <template #cell(user.prenom)="data">
        {{ getUsername(data.item.user) }}
      </template>     
      <template #cell(nature.titre)="data">
        <b-button  variant="dark" size="sm" v-if="data.item.nature_id">
          {{ $api.p('ReclamationNature', data.item.nature_id).titre }}
        </b-button>        
      </template>       
      <template #cell(canal.titre)="data">
        <b-button  variant="dark" size="sm" v-if="data.item.canal_id">
          {{ data.item.canal.titre }}
        </b-button>        
      </template>
      <template #cell(action_1)="data">
        <b-button-group>
          <b-button size="sm" class="btn-icon" variant="primary" @click="selectRec(data.item)"><i class="fas fa-eye"></i></b-button>
          <b-button size="sm" class="btn-icon" variant="light-danger" @click="removeModalRec(data.item)"><i class="fas" :class="data.item.status === 1 ? 'fa-trash' : 'fa-spin fa-spinner'"></i></b-button>
        </b-button-group>
      </template>            
    </Datatable>    
    <b-sidebar v-model="detailOpen" title="Sidebar" width="50%"  right shadow>
        <template #header="{ hide }">
          <b-row align-h="between" align-v="center" class="no-gutters w-100">      
            <b-col cols="2" class="d-flex align-items-center">
              <b-button variant="light-danger" size="sm" @click="detailOpen = false">
                <i class="fas fa-times mr-1"></i> Fermer
              </b-button>              
            </b-col>      
            <b-col cols="7" class="text-center">
              <h5 class="mb-0 font-weight-bold">Reclamation #{{recSelected.id}} - {{recSelected.nom}} {{ recSelected.prenom }}</h5>
            </b-col>      
            <b-col cols="3" class="d-flex justify-content-end align-items-center">              
              <b-button variant="success" size="sm" @click="save()">
                <i class="fas" :class="`${save_loader ? 'fa-spinner fa-spin' : 'fa-save'}`"></i> Sauvegarder
              </b-button>
            </b-col>
          </b-row>
        </template>
        <b-tabs class="mt-4" id="main-tabs" pills card align="center">
          <b-tab title="Information prospect" v-if="recSelected != false">
            <b-card class="card-search">              
                <b-row>                       
                  <FieldForm model="Reclamation" :obj="recSelected" field="nom"/>
                  <FieldForm model="Reclamation" :obj="recSelected" field="prenom"/>
                  <FieldForm model="Reclamation" :obj="recSelected" field="gestionnaire_id"/>                  
                  <FieldForm model="Reclamation" :obj="recSelected" field="user_id"/>
                  <FieldForm model="Reclamation" :obj="recSelected" field="resiliation_id"/>
                  <FieldForm model="Reclamation" :obj="recSelected" field="numero_contrat"/>
                  <FieldForm model="Reclamation" :obj="recSelected" field="canal_id"/>
                  <b-col md="6" v-if="recSelected.niveau_id">
                    <b-form-group label="Niveau">
                      <b-form-input :value="$api.p('ReclamationNiveau', recSelected.niveau_id).titre" :disabled="true" />
                    </b-form-group>
                  </b-col>
                  <FieldForm model="Reclamation" :obj="recSelected" field="nature_id"/>
                  <b-col md="12">
                    <b-form-group label="Contenu:">
                      <b-form-textarea v-model="recSelected.contenu" rows="7"></b-form-textarea>
                    </b-form-group>
                  </b-col>                                                                      
                </b-row>
                <b-row>
                  <FieldForm model="Reclamation" :obj="recSelected" field="date_reception"/>
                </b-row>
                <b-row>
                  <b-col md="6" cols="12">
                    <b-form-group label="Accusé de réception:">
                      <b-form-radio v-model="recSelected.accuse_reception" name="some-accuse_reception" :value="true">Oui</b-form-radio>
                      <b-form-radio v-model="recSelected.accuse_reception" name="some-accuse_reception" :value="false">Non</b-form-radio>
                    </b-form-group>                    
                  </b-col>                                    
                  <FieldForm v-if="recSelected.accuse_reception === true" model="Reclamation" :obj="recSelected" field="date_accuse_reception"/>                                                      
                </b-row>                
                <b-row>
                  <b-col md="6" cols="12">
                    <b-form-group label="Résolution:">
                      <b-form-radio v-model="recSelected.resolution" name="some-resolution" :value="true">Oui</b-form-radio>
                      <b-form-radio v-model="recSelected.resolution" name="some-resolution" :value="false">Non</b-form-radio>
                    </b-form-group>                    
                  </b-col>                  
                  <b-col md="6" cols="12">
                    <b-form-group label="Médiateur active:">
                      <b-form-radio v-model="recSelected.mediateur" name="some-mediateur" :value="true">Oui</b-form-radio>
                      <b-form-radio v-model="recSelected.mediateur" name="some-mediateur" :value="false">Non</b-form-radio>
                    </b-form-group>                    
                  </b-col>                  
                  <b-col md="6" cols="12">
                    <b-form-group label="Procedure / éscalade:">
                      <b-form-radio v-model="recSelected.procedure" name="some-procedure" :value="true">Oui</b-form-radio>
                      <b-form-radio v-model="recSelected.procedure" name="some-procedure" :value="false">Non</b-form-radio>
                    </b-form-group>                    
                  </b-col>                  
                  <b-col md="6" cols="12">
                    <b-form-group label="Devoir du conseiller:">
                      <b-form-radio v-model="recSelected.devoir_conseiller" name="some-devoir_conseiller" :value="true">Oui <small>- le devoir du conseiller est conforme</small></b-form-radio>
                      <b-form-radio v-model="recSelected.devoir_conseiller" name="some-devoir_conseiller" :value="false">Non <small>- le devoir du conseiller n’est pas conforme</small></b-form-radio>
                    </b-form-group>                    
                  </b-col>
                  <FieldForm model="Reclamation" :obj="recSelected" field="date_reponse_final"/>                  
                  <b-col md="12">
                    <b-form-group label="Action réalisées:">
                      <b-form-textarea v-model="recSelected.actions_realisees" rows="6"></b-form-textarea>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-card>    
              <b-card class="mt-3">
                <Commentaire v-model="recSelected.commentaire" label="actions correctives / observations"/>
              </b-card>        
          </b-tab>   
          <b-tab title="Documents" v-if="recSelected.id != null" class="p-2">
            <GED model="Reclamation" :model_id="recSelected.id" />
          </b-tab>               
        </b-tabs>
    </b-sidebar>
    <b-modal id="confirm-delete-reclamation" ref="confirmDeleteModal" title="Confirmation de suppression" hide-footer centered>
      <p v-if="recSelected != false" class="mb-5">
        Êtes-vous sûr de vouloir supprimer la réclamation <bold>n°{{ recSelected.id }}</bold> ?
      </p>
      <div class="d-flex justify-content-center">
        <b-button variant="secondary" class="mr-2" @click="$refs.confirmDeleteModal.hide()">
          Annuler
        </b-button>
        <b-button v-if="recSelected != false" variant="light-danger" @click="removeRec()">
          <span v-if="recSelected.status === 1">Supprimer</span>
          <i v-else class="fas fa-spin fa-spinner"></i>
        </b-button>
      </div>
    </b-modal>

  </div>
</template>
<script>
import Datatable from '@/components/Datatable';
import FieldForm from '@/components/FieldForm';
import Commentaire from '@/components/Commentaire';
import GED from '@/components/GED';

export default {
  name: "ClientListe",
  components: {
    Datatable, 
    FieldForm,
    Commentaire,
    GED
  },  
  data(){         
    return{
      filters:{},
      fields: [ 
        { key: 'id', label: 'Référence', sortable:true, }, 
        { key: 'nom', label: 'Nom', sortable:true, }, 
        { key: 'prenom', label: 'Prénom', sortable:true, }, 
        { key: 'canal.titre', label: 'Canal', sortable:true, }, 
        { key: 'numero_contrat', label: 'Numero de contrat', sortable:true, }, 
        { key: 'gestionnaire.titre', label: 'Gestionnaire', sortable:true, }, 
        { key: 'user.prenom', label: 'Commercial', sortable:true, }, 
        { key: 'nature.titre', label: 'Nature', sortable:true, },       
        { key: 'date_reception', label: 'Date réception', sortable:true, },
        { key: 'action_1', label: 'Action', sortable:false, },   
      ],      
      sort:{
        key: 'date_create',
        value: 'DESC'
      },    
      recSelected: false,  
      detailOpen: false,
      save_loader: false,
      saved: false,
      csv_loader: false
    }
  },
  computed:{    
  },
  watch:{
    detailOpen(v){
      if(v === false){
        if(this.saved === false){
            const confirmation = confirm("⚠️ Attention, vous n'avez pas sauvegardé. Voulez-vous quand même fermer la réclamation ?");
            console.log(confirmation);
            
            if(!confirmation){
              this.detailOpen = true; 
              return;
            }
        }
        console.log('jessy');
        
        this.recSelected = false;
        this.saved = false;
        this.$refs.datatable.datatableInit();
      }
    }
  },
  methods: {  
    selectRec(data){
      this.$api.ajax(`/reclamation/${data.id}`, null, res => {
        if(res.status){
          this.recSelected = res.data
          this.detailOpen = true;
        }
      })      
    },
    save(){
      if(this.save_loader) return false;
      this.$api.ajax('/reclamation/create', this.recSelected, res => {
        if(res.status){
          this.$bvToast.toast('Sauvegarder', {
            title: 'Sauvegarder',
            variant: 'success',
            solid: true
          });
          this.recSelected = res.data;
          this.saved = true;
        }
        this.save_loader = false;
      })
    },
    newRec(){
      if(this.save_loader) return 
      this.save_loader = true;
      this.$api.ajax('/reclamation/new', {}, res => {
        if(res.status){
          this.recSelected = res.data;
          this.detailOpen = true;
        }
        this.save_loader = false;
      })
    },
    tableToCSV(){
      if(this.csv_loader) return 
      this.csv_loader = true;
      let params = {filters:this.filters}
      this.$api.ajax('/reclamation/csv', params, res => {
        if(res.status){
          this.$api.base64ToCSV(res.data.base64, res.data.file_name);
          this.$refs.datatable.datatableInit();
        }
        this.csv_loader = false;
      })
    },
    removeModalRec(rec){      
      this.recSelected = rec;    
      this.$refs.confirmDeleteModal.show();  
    },
    removeRec(){
      if(this.recSelected.status === 0) return false;
      this.recSelected.status = 0;
      this.$api.ajax(`/reclamation/remove/${this.recSelected.id}`, null, res => {
        if(res.status){
          this.$refs.datatable.datatableInit();
          this.$refs.confirmDeleteModal.hide();  
          this.recSelected = false;    
        }
      })
    },
    getUsername(user = null){
      if(user){
        return `${user.prenom} ${user.nom[0]}`
      }
      return 'Inconnue';
    }
  },
  beforeMount() {
  },
  mounted() {        
  }
}
</script>
<style>
#main-tabs__BV_tab_controls_ > .nav-item .nav-link.active{
  color: white !important;
}
#main-tabs__BV_tab_container_ > .tab-pane.card-body{
  padding: 0px;
  margin-top: 10px;
}
#main-tabs > .card-header:first-of-type {
  padding: 1rem 1.25rem !important;
}
</style>
